module.exports = __webpack_public_path__ + "static/media/digi.a96049a2.png";